import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-received-promo',
  templateUrl: './received-promo.component.html',
  styleUrls: ['./received-promo.component.scss']
})
export class ReceivedPromoComponent extends FeaturesBaseComponent implements OnInit {
  searchValue: any;
  promocodeId: number;
  promoCodeData: any;
  gridApi: any;
  constructor(private activeRoute: ActivatedRoute, private promotionService: PromotionsService) {
    super();
    this.promocodeId = this.activeRoute.snapshot.params.id;
  }



  ngOnInit(): void {
    super.ngOnInit()

    this.promotionService.getUserHistoryList(this.promocodeId)
      .subscribe(
        res => {
          let _historylist: any = res;
          if (_historylist.httpcode == 200) {
            this.promoCodeData = _historylist.data;
           
          }
        }
      );

  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  changehistory(data) {

  }
  historyDays = [{ days: 30, value: 'Last 30 days' }, { days: 60, value: 'Last 60 days' }, { days: 90, value: 'Last 90 days' }];
  selectedDays = this.historyDays[0].days;
  promoCodeColumnDef: any = [
    // { field: "", headerName: "Action", checkboxSelection: true },
    { field: "consumerNumber", headerName: "Mobile Number" },
    { field: "email", headerName: "email_id" },
    { field: "state", headerName: "State" },
    { field: "subscription", headerName: "Subscription" },
    { field: "country", headerName: "Country" },
  ];

}
